import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { map } from "rxjs/operators";
import { EngagementEnum } from "./localstorage";
import { environment } from "src/environments/environment";
import { IStemexeModule } from "../data-providers/interfaces/interfaces";
import { StemexeDataProviderService } from "../data-providers/services/stemexe-data-provider.service";
// import { AuthService } from "../shared/services/auth.service";
import { DataProvider, PagedData, PagedDataItem } from "../data-providers/models/models";
import { AuthType } from "../shared/services/auth.service";
import { AuthService } from "../plannexe/shared/services/auth.service";

//EspDataProviderService class and it's usage is only for demo purpose.
@Injectable({
  providedIn: "root"
})
export class EngagementProDataProviderService implements IStemexeModule {
  type: AuthType = AuthType.Plannexe;
  user: any = {};

  constructor(
    private http: HttpClient,
    private authService: AuthService
  ) {
  }

  initialize(): void {
    this.user = localStorage.getItem(EngagementEnum.user);
    // if(this.user){
    this.user = JSON.parse(this.user ? this.user : '[]');
    // }
  }

  getDataProviders(providerType: string): Observable<DataProvider[]> {
    let engagementProvider: DataProvider[] = [];

    let user: any = localStorage.getItem(EngagementEnum.user);
    user = JSON.parse(user ? user : '[]');

    if (providerType == 'ActivitySource') {
      let reqDataProvider: DataProvider = new DataProvider();
      reqDataProvider.title = 'Engagement Pro';
      reqDataProvider.id = '2'; // see doc for more detail
      reqDataProvider.system = environment.engagementPro.baseURL;
      reqDataProvider.tenantId = this.authService.organizationId + ""; // engpro oraginzation id
      reqDataProvider.getData = (token) => {
        return this._getProviderData(reqDataProvider, token)
      }
      engagementProvider.push(reqDataProvider);
    }
    return of(engagementProvider);
  }
  private _getProviderData(provider: DataProvider, nextPageToken?: any): Observable<PagedData> {
    console.log('token', nextPageToken)
    if (provider.id === '1') {
      return this.http.get(environment.engagementPro.baseURL + '/api/OrganizationApi/GetMySpace', this.getURLHeaders()).pipe(
        map((result: any) => {
          let pagedData = new PagedData();
          pagedData.items = result.map((r: any) => {
            let item1 = new PagedDataItem();
            item1.id = r.Id;
            item1.extraData = {}
            item1.title = r.Title,
              item1.url = '/pages/engagement/' + r.Id;
            item1.getData = (token) => {
              let pagedData = new PagedData();
              return of(pagedData);
            }
            return item1;
          })
          return pagedData;
        })
      );
    }
    else {
      let pagedData = new PagedData();
      return of(pagedData);
    }
  }
  openUrl(url: string, context: any): any {
    if (url === '/pages/engagement/') {
      //asdf
    }
  }

  getURLHeaders(): any {
    return {
      headers: new HttpHeaders({
        Authorization: 'Bearer ' + localStorage.getItem(EngagementEnum.token)
      })
    }
  }
}